import classNames from "classnames"
import React, {ChangeEvent, useCallback, useRef, useState} from "react"
import {connect, useDispatch, useSelector} from "react-redux"
import {v4} from "uuid"
import {ResolvePlugin} from "webpack"
import request from "../../../util/request"
import Styles from "./upload.less"
const promiseType: {[name: string]: {size: number; valid: boolean}} = {
    pdf: {
        valid: true,
        size: 10 * 1024 * 1024,
    },
    jpg: {
        valid: true,
        size: 10 * 1024 * 1024,
    },
    jpeg: {
        valid: true,
        size: 10 * 1024 * 1024,
    },
    png: {
        valid: true,
        size: 10 * 1024 * 1024,
    },
    ofd: {
        valid: true,
        size: 10 * 1024 * 1024,
    },
}
interface AllowType {
    [type: string]: {
        size: number
    }
}
const allowType: AllowType = {
    png: {
        size: 8 * 1024 * 1024,
    },
    jpg: {
        size: 8 * 1024 * 1024,
    },
    jpeg: {
        size: 8 * 1024 * 1024,
    },
    pdf: {
        size: 10 * 1024 * 1024,
    },
}
const Upload = () => {
    const dispatch = useDispatch()
    const inputRef = useRef<HTMLInputElement>(null)
    const uploadFileList = useSelector((state: any) => state.uploadFileList)
    const fileSizeMax = useSelector((state: any) => state.fileSizeMax)
    const viewType = useSelector((state: any) => state.viewType)
    const [dragOver, setDragOver] = useState(false)
    const url = useSelector((state: any) => state.url)
    const model = useSelector((state: any) => state.model)
    const uploadFile = () => {
        const fileList = inputRef.current?.files
        let count = 0
        let uploadList = []
        if (fileList && fileList.length > 0) {
            for (let i = 0; i < fileList.length; i++) {
                const file: File = fileList[i]
                const type: string = file.name.slice(file.name.lastIndexOf(".") + 1).toLowerCase()
                if (!(type in allowType)) {
                    model.invokeAsync("resultData", {
                        code: "0",
                        message: "检测到不符合规范的文件类型。",
                    })
                    return
                }
                if (file.size > allowType[type].size) {
                    model.invokeAsync("resultData", {
                        code: "0",
                        message: "文件大小不符合规范。",
                    })
                    return
                }
                // TODO fileUpload promise.all 考虑多并发
                if (file && type in promiseType) {
                    if (promiseType[type] && count < fileSizeMax) {
                        count++
                        uploadList.push({file: file, type: type})
                    }
                }
            }
            Promise.all(uploadList.map((item) => toUrl(item.file, item.type))).then(
                (res) => {
                    dispatch({type: "startTesting", payload: res})
                    model.invokeAsync(viewType, res)
                    dispatch({
                        type: "clearUploadFileList",
                        payload: [],
                    })
                },
                (err) => {
                    // model.invokeAsync("resultData", {
                    //     code: "0",
                    //     message: err,
                    // })
                }
            )
            // Promise.all(uploadList.map((item) => toLocal(item.file, item.type))).then(
            //     (res) => {
            //         dispatch({type: "startTesting", payload: res})
            //         model.invoke(viewType, res)
            //     },
            //     (err) => console.log(err)
            // )
        }
    }

    const toLocal = async (file: File, type: string) => {
        return new Promise((resolve, reject) => {
            if (uploadFileList.length < fileSizeMax) {
                dispatch({
                    type: "uploadFile",
                    payload: {
                        fileName: file.name,
                        url: `res.url`,
                        status: "success",
                        fileType: type,
                    },
                })
                resolve({
                    fileName: file.name,
                    url: ` res.url`,
                    status: "success",
                    fileType: type,
                })
            }
        })
    }

    const toUrl = async (file: File, type: string) => {
        const form = new FormData()
        form.append("file", file)
        form.append("url", file.name)
        form.append("urlType", "pc")
        form.append("appId", "cvp")
        form.append("fId", "cvp_classifier")
        form.append("token", v4())
        return new Promise((resolve, reject) => {
            request(
                `${url}`,
                {
                    method: "POST",
                    body: form,
                },
                (res: any) => {
                    if (res.status === "success") {
                        if (uploadFileList.length < fileSizeMax) {
                            dispatch({
                                type: "uploadFile",
                                payload: {
                                    fileName: file.name,
                                    url: res.url,
                                    status: "success",
                                    fileType: type,
                                },
                            })
                            resolve({
                                fileName: file.name,
                                url: res.url,
                                status: "success",
                                fileType: type,
                                fileSize: file.size,
                            })
                        }
                    } else {
                        model.invokeAsync("resultData", {
                            code: "0",
                            message: res.description,
                        })
                        dispatch({
                            type: "clearUploadFileList",
                            payload: [],
                        })
                        reject("error")
                    }
                }
            )
        })
    }

    return (
        <div className={Styles.uploadArea}>
            <div className={Styles.fileUpload}>
                <input
                    ref={inputRef}
                    multiple
                    accept={",.png,.jpg,.jpeg,.pdf"}
                    type="file"
                    onChange={(e) => uploadFile()}
                    style={{display: "none"}}
                />
                <div className={Styles.fileListArea}>
                    <div className={Styles.top}>
                        <div
                            onDragEnter={(e) => {
                                setDragOver(true)
                                e.preventDefault()
                            }}
                            onDragOver={(e) => {
                                setDragOver(true)
                                e.preventDefault()
                            }}
                            onDragLeave={(e) => {
                                setDragOver(false)
                                e.preventDefault()
                            }}
                            onDrop={(e) => {
                                setDragOver(false)
                                e.preventDefault()
                                if (inputRef.current) {
                                    inputRef.current.files = e.dataTransfer.files
                                    uploadFile()
                                }
                            }}
                            className={classNames({
                                [Styles.uploadFileCommponent]: true,
                                [Styles.dragoverStyle]: dragOver,
                                // [Styles.uploadDisplay]: uploadFileList.length !== 0,
                            })}
                        >
                            <div
                                onClick={() => {
                                    inputRef && inputRef.current?.click()
                                }}
                                className={Styles.noDataCommponent}
                            >
                                <div className={Styles.noDataUpload}>
                                    <span className={Styles.noDataUploadTip}>+</span>
                                    <span>点击或拖拽上传</span>
                                </div>
                            </div>
                        </div>
                    </div>

                    <div className={Styles.warningTips}>
                        <span className={Styles.nav}>为保证分类和识别效果，请仔细阅读文件上传的要求：</span>
                        <span className={Styles.text}>
                            1、一次测试最多分类5页（张）文件或图片，超过数量的将不会被识别。
                        </span>
                        <span className={Styles.text}>2、支持pdf文档，单个文件大小不超过10M。 </span>
                        <span className={Styles.text}>
                            3、支持jpg、jpeg、png图像，单个图像的大小不超过8M，不小于1K。暂不支持混贴的图像分类。
                        </span>
                        <span className={Styles.text}>4、注意不可上传文字模糊、加密或损坏的文档和图像。</span>
                    </div>
                </div>
            </div>
        </div>
    )
}

export default Upload
